/*
 * Copyright (c) 2012-present Sedicii Innovations Ltd.
 *
 * All rights reserved.
 */

import { Base64 } from 'js-base64'

import configuration from '../configuration'

export const KYC_VERIFICATION_FORM_LOADED_SUCCESS = 'KYC_VERIFICATION_FORM_LOADED_SUCCESS'
export const KYC_VERIFICATION_STEPS_LOADED_SUCCESS = 'KYC_VERIFICATION_STEPS_LOADED_SUCCESS'
export const KYC_VERIFICATION_UPLOAD_REQUESTED = 'KYC_VERIFICATION_UPLOAD_REQUESTED'
export const KYC_VERIFICATION_UPLOAD_SUCCESS = 'KYC_VERIFICATION_UPLOAD_SUCCESS'
export const KYC_VERIFICATION_UPLOAD_ERROR = 'KYC_VERIFICATION_UPLOAD_ERROR'

const steps = [
  {
    title: 'Identity',
    formsIds: [ 'generic-user-picture', 'choice:identity' ],
    forms: [],
    choice: {
      identity: {
        componentName: 'ChooseForm',
        choices: {
          passport: {
            formsIds: [ 'generic-passport', 'generic-passport-picture' ],
            forms: []
          },
          driversLicence: {
            formsIds: [ 'eu-drivers-license', 'drivers-licence-picture-front', 'drivers-licence-picture-back' ],
            forms: []
          },
          idCard: {
            formsIds: [ 'id-card', 'id-card-picture-front', 'id-card-picture-back' ],
            forms: []
          }
        }
      }
    }

  },
  {
    title: 'Address',
    formsIds: [ 'generic-utility-bill', 'generic-utility-bill-picture' ],
    forms: []
  }
]

const finalStep = {
  title: 'Finish',
  forms: [
    {
      componentName: 'TermsAndConditions'
    },
    {
      componentName: 'Consent'
    },
    {
      componentName: 'SubmitDocuments'
    }
  ]
}

export function loadSteps () {
  return (dispatch, getState) => {
    const token = getState().kycAuth.token
    Promise.all(
      steps.map(step => {
        return Promise
          .all(step.formsIds.map(formId => loadForm({ token, step, formId })))
          .then(responses => {
            step.forms = responses
          })
      })
    ).then(() => {
      [ ...steps, finalStep ].forEach(step => dispatch({
        type: KYC_VERIFICATION_FORM_LOADED_SUCCESS,
        payload: step
      }))
    }).then(() => {
      dispatch({
        type: KYC_VERIFICATION_STEPS_LOADED_SUCCESS
      })
    })
  }
}

export function uploadDocuments ({ formValues }) {

  const documents = getDocumentFromFormValues(formValues)

  return (dispatch, getState) => {
    const userId = getState().kycAuth.userId
    const token = getState().kycAuth.token

    dispatch({ type: KYC_VERIFICATION_UPLOAD_REQUESTED })

    Promise.all(documents.map(({ filename, file }) => {
      return fetch(`/api/users/${ userId }/documents/${ filename }`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${ token }`,
          'Content-Type': 'application/octet-stream',
          'X-RP-Id': configuration.RELYING_PARTY_ID
        },
        body: file
      })
    })
    ).then(responses => {
      const hasError = responses.some(response => response.status > 299)
      dispatch({ type: hasError ? KYC_VERIFICATION_UPLOAD_ERROR : KYC_VERIFICATION_UPLOAD_SUCCESS })
    })
  }
}

function loadForm ({ token, step, formId }) {
  if (formId.indexOf('choice:') === 0) {
    const choice = step.choice[ formId.replace('choice:', '') ]

    return loadChoice({ token, step, choice })
  }

  return fetch(`/api/identity-providers/${ formId }/attributes-definition`, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${ token }`,
      'Content-Type': 'application/json'
    }
  }).then(response => response.json())
}

function loadChoice ({ token, step, choice }) {
  return new Promise((resolve, reject) => {
    Promise.all(Object.keys(choice.choices).map(key => {
      return Promise
        .all(choice.choices[ key ].formsIds.map(formId => loadForm({ token, step, formId })))
        .then(responses => {
          choice.choices[ key ].forms = responses
        })
    }))
      .then(() => resolve(choice), reject)
  })
}

function stringToBytes (value) {
  const bytes = new Uint8Array(new ArrayBuffer(value.length))
  for (let i = 0, max = value.length; i < max; i++) {
    bytes[ i ] = value.charCodeAt(i)
  }
  return bytes
}

function getDocumentFromFormValues (formValues) {
  const documents = []
  Object.keys(formValues).forEach(formKey => {
    const formValue = formValues[ formKey ]
    if (!formValue) {
      return
    }

    const documentName = `${ formKey }.json`
    const documentFile = { ...formValue }
    Object.keys(formValue).forEach(attributeKey => {
      const attributeValue = formValue[ attributeKey ]
      if (attributeValue && attributeValue.indexOf('data:image/png;base64,') === 0) {
        const imageFileName = `${ formKey }_${ attributeKey }.png`
        documents.push({
          filename: imageFileName,
          file: stringToBytes(Base64.atob(attributeValue.replace('data:image/png;base64,', '')))
        })
        documentFile[ attributeKey ] = imageFileName
      }
    })

    documents.push({
      filename: documentName,
      file: stringToBytes(JSON.stringify(documentFile))
    })
  })
  return documents
}
